import { useRPCContext } from "../../../contexts/RPCContext.js";
import { SelectLocationRenderComponents } from "./SelectLocation.js";
import { useEffect, useState } from "react";
import { Icon, MultiSelect } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
//#region src/modules/Locations/shared/SearchFilterLocationMultiSelect.tsx
var LIMIT = 25;
function SearchFilterLocationMultiSelect({ focused, label = "Locations", onChange, onClearSelection, onClick, value }) {
	const [totalOptions, setTotalOptions] = useState(0);
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const { rpcService } = useRPCContext();
	useEffect(() => {
		setLoading(true);
		rpcService.Locations.GetLocationsList.v1.call({ pagination: { limit: LIMIT } }).then(({ data }) => {
			setTotalOptions(data.total);
			setOptions(data.locations);
		}).finally(() => setLoading(false));
	}, []);
	const handleLoadOptions = (opts) => {
		if (opts?.additional && options.length < totalOptions) rpcService.Locations.GetLocationsList.v1.call({
			pagination: {
				limit: LIMIT,
				skip: options.length
			},
			searchText: opts.text
		}).then(({ data }) => {
			setOptions((prevOptions) => [...prevOptions, ...data.locations]);
		});
		else if (opts.text) rpcService.Locations.GetLocationsList.v1.call({
			pagination: { limit: LIMIT },
			searchText: opts.text
		}).then(({ data }) => {
			setOptions(data.locations);
		});
	};
	return /* @__PURE__ */ jsx("div", {
		className: "bg-surface-strong p-xs",
		children: /* @__PURE__ */ jsxs("div", {
			className: "space-y-sm w-full font-bold",
			onClick,
			children: [/* @__PURE__ */ jsxs("span", {
				className: "flex w-full justify-between hover:cursor-pointer",
				children: [/* @__PURE__ */ jsx("span", { children: label }), /* @__PURE__ */ jsx("span", { children: focused ? /* @__PURE__ */ jsx(Icon, { Icon: MdExpandLess }) : /* @__PURE__ */ jsx(Icon, { Icon: MdExpandMore }) })]
			}), focused && /* @__PURE__ */ jsx("div", {
				onClick: (e) => e.stopPropagation(),
				children: /* @__PURE__ */ jsx(MultiSelect, {
					disabled: loading,
					disableSelectAll: true,
					loading,
					onChangeValue: onChange,
					onClearSelection,
					loadOptions: handleLoadOptions,
					optionLabelExtractor: (option) => option.name,
					options,
					optionValueExtractor: (option) => option.id || "",
					placeholder: "Location",
					renderOption: SelectLocationRenderComponents.ListItem,
					totalOptions,
					value: value || []
				})
			})]
		})
	});
}
//#endregion
export { SearchFilterLocationMultiSelect };

//# sourceMappingURL=SearchFilterLocationMultiSelect.js.map